import { ActionReducerMap, createFeatureSelector, StoreModule } from '@ngrx/store';

import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { reducer as listReducer} from './list/reducer';
import { reducer as errorsReducer} from './errors/reducer';
import { FeatureEffects as ListEffects } from './list/effects';
import { FeatureState } from './settings';
import { ItemModalComponent } from '../components/item-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ConfigModalComponent } from '../components/config-modal.component';

const reducers: ActionReducerMap<FeatureState> = {
    list: listReducer,
    errors: errorsReducer
}

@NgModule({
    declarations: [
        ItemModalComponent,
        ConfigModalComponent,
    ],
    imports: [
        NgbModalModule,
        ReactiveFormsModule,
        CommonModule,
        NgSelectModule,
        StoreModule.forFeature('utenti', reducers),
        EffectsModule.forFeature([ListEffects])
    ],
    entryComponents: [
        ItemModalComponent,
      ConfigModalComponent
    ]
})

export class FeatureStoreModule {
}


